import React, { useContext, useEffect, useState } from 'react'
import { SizeContext } from '../../contexts/resize-context';

export const useVerticalSecondaryModule = ({ verticalSecondaryModule = null, appliedCssClassNames = ''}) => {
  
  const getButtonAppliedCssClassNames = () => { 
    const styleSystem = appliedCssClassNames?.split(' ') || null
    return styleSystem?.filter(v => v.startsWith('button_')).join(' ') || ''
  }

  return {
    ...verticalSecondaryModule,
    featureText: verticalSecondaryModule.featuretext,
    featureTextColor: verticalSecondaryModule.featuretextcolor,
    featureBackgroundColor: verticalSecondaryModule.featurebackgroundcolor,
    iconFont: verticalSecondaryModule.iconfont,
    verticalSecondaryModule,
    buttonAppliedCssClassNames: getButtonAppliedCssClassNames(),
    onlyIconFont: verticalSecondaryModule?.iconfont || false,
    onlyImage: verticalSecondaryModule?.image?.path && !verticalSecondaryModule?.iconfont,
    video: verticalSecondaryModule.video,
  }
}
